import api from '~/plugins/apiClient';
import { ApiHandler, ApiResponseContext } from '~/plugins/apiClient/_types';
import { formatApiUrl } from '~/plugins/apiClient/utils';
import { FetchDashboardResponse, FetchDashboardResponseSchema } from './_types';
import { transformZodSchemaFn } from '~/plugins/zod/utils';

const apiEndpointPrefix = 'dashboard';

export const fetchDashboardRequest: ApiHandler<ApiResponseContext<FetchDashboardResponse>> = async () => {
    const url = formatApiUrl(apiEndpointPrefix);
    return api.get(url, { transform: transformZodSchemaFn(FetchDashboardResponseSchema, url) });
};
